import { Box, Button, Card, CircularProgress, Typography } from "@mui/material";
import { useCustomMutation } from "@refinedev/core";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "../../../../hooks/useTranslation";
import { useQueryClient } from "@tanstack/react-query";

export const AuthorizationCallback = () => {
  const { translate } = useTranslation("pages.stores.create.amazonIntegration");
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const { mutate } = useCustomMutation();
  const queryClient = useQueryClient();
  const [authorizationState, setAuthorizationState] = useState<
    "initial" | "loading" | "error"
  >("initial");

  useEffect(() => {
    tryAuthorize();
  }, []);

  const handleAuthorization = (
    authCode: string,
    state: string,
    storeName: string,
    amazonSellerId: string,
  ) => {
    if (authorizationState === "loading") return;
    setAuthorizationState("loading");

    mutate(
      {
        url: "authorization/complete",
        method: "post",
        values: {
          authCode,
          state,
          amazonSellerId,
          storeName,
        },
      },
      {
        onError: () => {
          setAuthorizationState("error");
        },
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: ["initialMarketplace"],
          });

          setTimeout(() => {
            navigate("/");
            navigate(0);
          }, 1000);
        },
      },
    );
  };

  const tryAuthorize = () => {
    const authCode = searchParams.get("spapi_oauth_code");
    const amazonSellerId = searchParams.get("selling_partner_id");
    const state = searchParams.get("state");
    const storeName = localStorage.getItem("storeName");

    if (authCode && state && storeName && amazonSellerId) {
      handleAuthorization(authCode, state, storeName, amazonSellerId);
    } else {
      navigate("/store/create");
    }
  };

  return (
    <Box width="100%" display="flex" justifyContent="center">
      <Card
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          padding: "24px",
          width: "fit-content",
          height: "200px",
          flexDirection: "column",
        }}
      >
        <Typography variant="h6">
          {authorizationState === "error"
            ? translate("error")
            : translate("authorizing")}
        </Typography>
        {authorizationState === "error" ? (
          <Button variant="contained" onClick={tryAuthorize}>
            {translate("tryAgain")}
          </Button>
        ) : (
          <CircularProgress />
        )}
      </Card>
    </Box>
  );
};
